module.exports = __webpack_public_path__ + "static/media/bootstrap-icons.7fb23f3b.woff";